import { useOrderProfileStore } from '../store/useOrderProfileStore';
import { OrderProfileServiceImpl } from './OrderProfileServiceImpl';
import { IOrderProfileService } from './IOrderProfileService';
import { OrderProfileServiceLogDecorator } from './OrderProfileServiceLogDecorator';
import { OrderProfileServiceExceptionDecorator } from './OrderProfileServiceExceptionDecorator';
import { OrderProfileServiceHistoryDecorator } from './OrderProfileServiceHistoryDecorator';

export class OrderProfileServiceFactory {
  private static instance: OrderProfileServiceFactory | null = null;
  private orderProfileStore: typeof useOrderProfileStore;

  public static initialize(orderProfileStore: typeof useOrderProfileStore) {
    OrderProfileServiceFactory.instance = new OrderProfileServiceFactory(orderProfileStore);
  }

  public static getInstance() {
    if (OrderProfileServiceFactory.instance === null) {
      throw new Error(
        'OrderProfileServiceFactory not yet initialized. Call OrderProfileServiceFactory.initialize() first.',
      );
    }
    return OrderProfileServiceFactory.instance;
  }

  private constructor(orderProfileStore: typeof useOrderProfileStore) {
    this.orderProfileStore = orderProfileStore;
  }

  public createOrderProfileService(): IOrderProfileService {
    let result: IOrderProfileService = this.makeOrderProfileService();

    result = new OrderProfileServiceExceptionDecorator(result);
    result = new OrderProfileServiceHistoryDecorator(result);
    result = new OrderProfileServiceLogDecorator(result);

    return result;
  }

  private makeOrderProfileService(): IOrderProfileService {
    return new OrderProfileServiceImpl(this.orderProfileStore);
  }
}
